import { useEffect } from "react";
import "@scss/pages/question-answer.scss";

import { $UserAddPermissions, ACTIONS } from "@store/user-store";

import { FeedBackBlock } from "@feature/feedback";
import { useUnit } from "effector-react";
import { setTitle } from "@store/title-store";

const Feedbacks: React.FC = () => {
  const permissions = useUnit($UserAddPermissions);

  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Техподдержка", href: "/feedback" },
    ]);
  }, []);

  return (
    <>
      <main className="content-container">
        <div className="content-section">
          {permissions.hasPermission(ACTIONS.support_questions_allowedToAsk) && (
            <section className="qa-tab-items full-width">
              <FeedBackBlock />
            </section>
          )}
        </div>
      </main>
    </>
  );
};

export default Feedbacks;
